export const dialogSection = state => {
  return state.dialogSection;
};


